export default "__VITE_ASSET__B0dHi_CI__"